import { ofType } from 'redux-observable';
import { concat, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PLAYLIST_ENDPOINT_URL } from '../../../common/constants/request';

import logger from '../../../common/helpers/logger';
import { includeFeatures, tmPostRequest } from '../../../common/helpers/request';
import { getFormattedVideo } from '../../../common/helpers/video';
import * as commonSelectors from '../../../common/redux/selectors/common';
import {
  singleVideoFetchErrorAction,
  singleVideoFetchStartedAction,
  singleVideoFetchSuccessAction,
} from '../slices/single';

export default (action$, state$) =>
  action$.pipe(
    ofType(singleVideoFetchStartedAction.type),
    switchMap(({ payload: { matchingId } }) => {
      const publisher = commonSelectors.publisherSelector(state$.value);
      const player = commonSelectors.playerSelector(state$.value);

      const stream$ = tmPostRequest({
        url: PLAYLIST_ENDPOINT_URL,
        body: {
          videoHub: true,
          publisherId: publisher.slug,
          widgetId: player.name,
          url: window.location.href,
          matchingId,
          includeSource: true,
          ...includeFeatures(state$.value),
        },
      }).pipe(
        map(({ response }) => {
          const { playlist, errors, ...playerPropsPassThrow } = response ?? {};

          return singleVideoFetchSuccessAction({
            playerPropsPassThrow,
            playlist: (playlist || [])
              .filter(({ mediaid }) => mediaid === matchingId)
              .map((video) =>
                getFormattedVideo(video, {
                  signedUrlExp: playerPropsPassThrow.signedUrlExp,
                }),
              ),
          });
        }),
        catchError((error) => {
          logger.error('modules/PlayerOverview/redux/epics/getSingleOverview', error);

          return of(singleVideoFetchErrorAction());
        }),
      );

      return concat(stream$);
    }),
  );
